var _defs, _clipPath, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 1024",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1024,
    width: 1024,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Capa-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41741 511.428C4.41741 228.485 232.053-0.885222 512.857-0.885222C793.66-0.885222 1021.3 228.485 1021.3 511.428C1021.3 794.37 793.66 1023.74 512.857 1023.74C232.053 1023.74 4.41741 794.37 4.41741 511.428Z",
    fill: "#90bdf9",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.029 384.398C254.029 331.443 296.291 288.515 348.424 288.515C400.558 288.515 442.82 331.443 442.82 384.398C442.82 437.352 400.558 480.28 348.424 480.28C296.291 480.28 254.029 437.352 254.029 384.398Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.678 390.344C596.678 337.389 638.941 294.461 691.074 294.461C743.207 294.461 785.47 337.389 785.47 390.344C785.47 443.298 743.207 486.226 691.074 486.226C638.941 486.226 596.678 443.298 596.678 390.344Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.492 817.933C404.802 794.774 400.917 747.054 405.499 722.582C417.997 655.832 478.791 612.504 549.446 616.061C563.691 616.779 584.792 622.649 595.636 631.096C651.761 674.814 667.567 747.862 635.148 807.992",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.65 139.86L483.7 340.544",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.849 140.604L564.717 336.828",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.b9ca04a12c2d9e324b85ffd153bbc433.svg";
export { ForwardRef as ReactComponent };